<template>
  <div class="userPage">
    <b-row class="pageTitle">
      <b-col cols="12" class="d-flex mb-3">
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <transition name="slide">
          <div>
            <b-card>
              <div slot="header">
                <b-row align-h="between">
                  <b-col cols="6">
                    <b>Thống kê số lượng truy cập</b>
                  </b-col>
                  <b-col cols="6"></b-col>
                </b-row>

              </div>
              <AnalyticsData/>

            </b-card>

            <b-card>
              <div slot="header">
                <b-row align-h="between">
                  <b-col cols="6">
                    <b>Thống kê tần suất sử dụng các tiêu chí</b>
                  </b-col>
                  <b-col cols="6"></b-col>
                </b-row>
              </div>
              <div>
                <CriteriaUsageTable/>
              </div>
            </b-card>
          </div>


        </transition>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CriteriaUsageTable from '@/components/CriteriaUsageTable';
import AnalyticsData from '@/components/AnalyticsData';

export default {
  name: "UserOverview",
  components: {
    CriteriaUsageTable,
    AnalyticsData,
  },
}
</script>

<style scoped>

</style>
